import React from 'react';
import {
  Monitor,
  Laptop,
  Briefcase,
  Coffee,
  Armchair,
  Gamepad2,
  Sprout,
  DoorOpen,
  Box,
  Building,
  Building2,
  Utensils,
  Printer,
  Bath,
  UserCheck,
  Target,
  BookOpen,
  Lightbulb,
  Sparkles,
  Headphones,
  Zap,
  Sofa,
  Trees,
  Palette,
  TrendingUp,
  Shield,
  Trophy,
  Settings,
  ClipboardList,
  FlaskConical,
  Users,
  Grid,
  Layers,
  Phone,
  Server,
  Wrench,
  GlassWater,
  PartyPopper,
  Compass,
  Gem,
  Sun,
  Flame,
  Globe,
  MessageSquare,
  Mail,
  Smartphone,
  ShoppingCart,
  BarChart2,
  Square,
  HelpCircle,
  Clock,
  Key,
  Folder,
  Sliders,
  CheckCircle,
  AlertCircle,
  FileText,
  CreditCard,
  HardDrive,
  Cpu,
  Radio,
  Tv,
  Camera,
  Video,
  Mic,
  Disc,
  Bookmark,
  DollarSign,
  Send,
  Inbox,
  Calendar,
  Tag,
  Paperclip,
  Trash2,
  Lock,
  Unlock,
  Hammer,
  Activity,
  Award,
  CircleDot,
  RadioTower,
  Bell,
  Volume2,
  VolumeX,
  Music,
  MapPin,
  Maximize2,
  Eye,
  Scissors,
  ShoppingBag,
  ShieldAlert,
  Rocket,
  LucideIcon,
} from 'lucide-react';

interface AppIconProps {
  icon?: string | null;
  name?: string;
  category?: string;
  role?: string;
  type?: string;
  className?: string;
  size?: number;
  color?: string;
}

const ICON_MAP: Record<string, LucideIcon> = {
  // Navigation & Core Tools
  diagramador: Grid,
  diagram: Grid,
  simulation: Activity,
  simulacion: Activity,
  room_templates: Building,
  room: Building,
  habitacion: Building,
  habitaciones: Building,
  zone: Building,
  zona: Building,
  zonas: Building,
  floor: Layers,
  suelo: Layers,
  furniture: Box,
  recursos: Box,
  recurso: Box,
  agents: Users,
  agentes: Users,
  mcp: Zap,

  // Location Types
  office: Building,
  sede: Building,
  principal: Building,
  warehouse: Box,
  almacen: Box,
  branch: Building2,
  sucursal: Building2,
  store: ShoppingBag,
  tienda: ShoppingBag,
  lab: FlaskConical,
  laboratorio: FlaskConical,
  hub: Layers,
  coworking: Users,
  default: Building,

  // Agent Roles
  devops: Wrench,
  frontend: Palette,
  backend: Settings,
  qa: FlaskConical,
  support: MessageSquare,
  data: TrendingUp,
  marketing: Rocket,
  manager: ClipboardList,
  bot: Cpu,
  agent: Users,
  user: UserCheck,

  // Room Types
  work: Laptop,
  meeting: Users,
  human_interaction: UserCheck,
  breakroom: Coffee,
  restroom: Bath,
  server_room: Server,
  lounge: Sofa,
  reception: Building,
  custom: Sparkles,

  // Furniture / Items
  desk_single: Laptop,
  cubicle_double: Monitor,
  executive_desk: Briefcase,
  chair_office: Armchair,
  wall_brick: Maximize2,
  wall_glass: Maximize2,
  door_single: DoorOpen,
  coffee_station: Coffee,
  water_dispenser: GlassWater,
  fridge: Box,
  snack_table: Utensils,
  sofa: Sofa,
  vending_machine: Box,
  toilet: Bath,
  sink: GlassWater,
  bathroom_stall: Bath,
  whiteboard: ClipboardList,
  meeting_table: Users,
  tv_screen: Tv,
  printer_large: Printer,
  filing_cabinet: Folder,
  plant_monstera: Sprout,
  air_conditioner: Sun,
  robot_vacuum: Cpu,
  trash_can: Trash2,

  // Categories
  workstation: Laptop,
  structure: Maximize2,
  cafeteria: Coffee,
  equipment: Wrench,
  wellness: Coffee,
  hygiene: Bath,
  productivity: Laptop,
  collaboration: Users,
  logistics: Box,

  // Floors / Materials
  wood_parquet: Layers,
  blue_checkered: Grid,
  grey_carpet: Square,
  terracotta: Square,
  bathroom_tile: Bath,
  breakroom_tile: Coffee,
  marble_luxury: Gem,
  cyber_deck: Zap,

  // MCP Tools
  '💬': MessageSquare,
  'mcp-send-sms': MessageSquare,
  sms: MessageSquare,
  '📧': Mail,
  'mcp-send-email': Mail,
  email: Mail,
  '📱': Smartphone,
  'mcp-send-whatsapp': Smartphone,
  whatsapp: Smartphone,
  '🛒': ShoppingCart,
  'mcp-manage-order': ShoppingCart,
  order: ShoppingCart,
  '📊': BarChart2,
  'mcp-accounting': BarChart2,
  accounting: BarChart2,

  // Floors & Materials
  '🪵': Layers,
  '🔷': Grid,
  '⏹️': Square,
  '🧶': Layers,
  '💎': Gem,
  '🌿': Sprout,
  '🏺': Box,
  '🏭': Building2,
  '🟩': Square,
  '🟦': Square,
  '⬜': Square,
  '🟫': Square,
  '🧱': Grid,
  '🔵': CircleDot,
  '🟢': CircleDot,
  '🪙': Award,
  '♟️': Grid,
  '🌊': Activity,
  '🍂': Sprout,
  '🌸': Sparkles,
  '🔮': Sparkles,
  '🧊': Box,
  '🏮': Lightbulb,
  '🌌': Sparkles,
  '🏛️': Building2,
  '⭐': Sparkles,
  '🪞': Maximize2,
  '🍫': Square,
  '🍯': Sparkles,
  '🍃': Sprout,
  '🟤': CircleDot,
  '🪐': Globe,
  '💫': Sparkles,
  '🛸': Server,
  '🏜️': Sun,
  '🌴': Trees,
  '🏔️': Compass,
  '🌾': Sprout,
  '🍁': Sprout,
  '🥇': Trophy,
  '🥈': Award,
  '🥉': Award,

  // Furniture / Items / Actions
  '💻': Laptop,
  '💼': Briefcase,
  '☕': Coffee,
  '🪑': Armchair,
  '🎮': Gamepad2,
  '🌱': Sprout,
  '🚪': DoorOpen,
  '📦': Box,
  '🏢': Building,
  '🍽️': Utensils,
  '🖨️': Printer,
  '🚻': Bath,
  '👔': UserCheck,
  '🎯': Target,
  '📚': BookOpen,
  '💡': Lightbulb,
  '🌟': Sparkles,
  '🎧': Headphones,
  '⚡': Zap,
  '🛋️': Sofa,
  '🎨': Palette,
  '📈': TrendingUp,
  '📉': BarChart2,
  '🔒': Lock,
  '🔓': Unlock,
  '🏆': Trophy,
  '⚙️': Settings,
  '📋': ClipboardList,
  '🔬': FlaskConical,
  '👥': Users,
  '🚿': Bath,
  '🛁': Bath,
  '🚽': Bath,
  '🍕': Utensils,
  '🧘': Activity,
  '📞': Phone,
  '☎️': Phone,
  '🖥️': Monitor,
  '🛡️': Shield,
  '🧰': Wrench,
  '🛠️': Wrench,
  '🔧': Wrench,
  '🔨': Hammer,
  '🍹': GlassWater,
  '🎪': PartyPopper,
  '📐': Compass,
  '🏖️': Sun,
  '🧩': Layers,
  '🧪': FlaskConical,
  '🔥': Flame,
  '🌍': Globe,
  '🤖': Cpu,
  '🔑': Key,
  '🗄️': Folder,
  '🗃️': Folder,
  '🗑️': Trash2,
  '🚰': Bath,
  '🥋': Activity,
  '🎤': Mic,
  '🎬': Video,
  '🤝': Users,
  '🔭': Compass,
  '📡': RadioTower,
  '📻': Radio,
  '🛑': AlertCircle,
  '🏷️': Tag,
  '📎': Paperclip,
  '📌': Bookmark,
  '📍': MapPin,
  '🚩': Target,
  '🎛️': Sliders,
  '🕹️': Gamepad2,
  '🔋': Zap,
  '🔌': Zap,
  '🔦': Lightbulb,
  '🕯️': Lightbulb,
  '🧯': ShieldAlert,
  '🚨': AlertCircle,
  '🧲': Zap,
  '🧬': Activity,
  '📺': Tv,
  '📼': HardDrive,
  '📷': Camera,
  '📸': Camera,
  '📹': Video,
  '🎥': Video,
  '📽️': Video,
  '🎞️': Video,
  '🎙️': Mic,
  '🎚️': Sliders,
  '🎷': Music,
  '🎸': Music,
  '🎹': Music,
  '🎺': Music,
  '🎻': Music,
  '🥁': Music,
  '📲': Smartphone,
  '📟': Radio,
  '📠': Printer,
  '⌨️': Laptop,
  '🖱️': Monitor,
  '💽': HardDrive,
  '💾': HardDrive,
  '💿': Disc,
  '📀': Disc,
  '🧮': BarChart2,
  '🔍': Target,
  '🔎': Target,
  '📔': BookOpen,
  '📕': BookOpen,
  '📖': BookOpen,
  '📗': BookOpen,
  '📘': BookOpen,
  '📙': BookOpen,
  '📓': BookOpen,
  '📒': BookOpen,
  '📃': FileText,
  '📜': FileText,
  '📄': FileText,
  '📰': FileText,
  '🗞️': FileText,
  '📑': FileText,
  '🔖': Bookmark,
  '💰': DollarSign,
  '💴': DollarSign,
  '💵': DollarSign,
  '💶': DollarSign,
  '💷': DollarSign,
  '💸': DollarSign,
  '💳': CreditCard,
  '🧾': FileText,
  '✉️': Mail,
  '📨': Mail,
  '📩': Mail,
  '📤': Send,
  '📥': Inbox,
  '📫': Mail,
  '📪': Mail,
  '📬': Mail,
  '📭': Mail,
  '📮': Mail,
  '📯': Bell,
  '📅': Calendar,
  '📆': Calendar,
  '📇': Users,
  '📏': Compass,
  '✂️': Scissors,
  '🔏': Lock,
  '🔐': Lock,
  '🗝️': Key,
  '🪓': Hammer,
  '⛏️': Hammer,
  '⚒️': Hammer,
  '🗡️': Shield,
  '⚔️': Shield,
  '🔩': Settings,
  '🗜️': Settings,
  '⚖️': Sliders,
  '🔗': Paperclip,
  '⛓️': Paperclip,
  '⚗️': FlaskConical,
  '🧫': FlaskConical,
  '💉': Activity,
  '🩸': Activity,
  '💊': Activity,
  '🩹': Activity,
  '🩺': Activity,
  '🪟': Maximize2,
  '🛏️': Armchair,
  '🧴': Bath,
  '🧷': Paperclip,
  '🧹': Sparkles,
  '🧺': Box,
  '🧻': Bath,
  '🪣': Bath,
  '🧼': Bath,
  '🧽': Bath,
  '🚬': AlertCircle,
  '⚰️': Box,
  '🪦': Box,
  '🧿': Eye,
  '🗿': Trophy,
  '🪆': Trophy,
  '🪩': Sparkles,
  '🪢': Paperclip,
  '🧵': Activity,
  '🪡': Activity,
  '👓': Eye,
  '🕶️': Eye,
  '🥽': Eye,
  '🥼': UserCheck,
  '🦺': UserCheck,
  '👕': UserCheck,
  '👖': UserCheck,
  '🧣': UserCheck,
  '🧤': UserCheck,
  '🧥': UserCheck,
  '🧦': UserCheck,
  '👗': UserCheck,
  '👘': UserCheck,
  '🥻': UserCheck,
  '🩱': UserCheck,
  '🩲': UserCheck,
  '🩳': UserCheck,
  '👙': UserCheck,
  '👚': UserCheck,
  '👛': ShoppingBag,
  '👜': ShoppingBag,
  '👝': ShoppingBag,
  '🛍️': ShoppingBag,
  '🎒': ShoppingBag,
  '🩴': UserCheck,
  '👞': UserCheck,
  '👟': UserCheck,
  '🥾': UserCheck,
  '🥿': UserCheck,
  '👠': UserCheck,
  '👡': UserCheck,
  '🩰': UserCheck,
  '👢': UserCheck,
  '👑': Award,
  '👒': UserCheck,
  '🎩': UserCheck,
  '🎓': Award,
  '🧢': UserCheck,
  '🪖': Shield,
  '⛑️': ShieldAlert,
  '📿': Award,
  '💄': Sparkles,
  '💍': Gem,
  '🔇': VolumeX,
  '🔈': Volume2,
  '🔉': Volume2,
  '🔊': Volume2,
  '📢': Volume2,
  '📣': Volume2,
  '🔔': Bell,
  '🔕': VolumeX,
  '🎼': Music,
  '🎵': Music,
  '🎶': Music,
  '🪗': Music,
  '🪕': Music,
  '🪘': Music,
  '🌳': Trees,
};

export const AppIcon: React.FC<AppIconProps> = ({
  icon,
  name,
  category,
  role,
  type,
  className = 'twin-icon-sm',
  size,
  color,
}) => {
  const trimmed = (icon || '').trim();
  const rawKey = trimmed.replace(/[\uFE0F\u200D]/g, '');
  const lowerName = (name || '').toLowerCase();
  const lowerCat = (category || '').toLowerCase();
  const lowerRole = (role || '').toLowerCase();
  const lowerType = (type || '').toLowerCase();

  let IconComponent =
    ICON_MAP[trimmed] ||
    ICON_MAP[rawKey] ||
    ICON_MAP[lowerType] ||
    ICON_MAP[lowerRole] ||
    ICON_MAP[lowerCat] ||
    ICON_MAP[lowerName];

  if (!IconComponent) {
    if (lowerName.includes('mesa') || lowerName.includes('escritorio') || lowerName.includes('desk')) {
      IconComponent = Laptop;
    } else if (lowerName.includes('silla') || lowerName.includes('chair') || lowerName.includes('sofa') || lowerName.includes('butaca')) {
      IconComponent = Armchair;
    } else if (lowerName.includes('reunion') || lowerName.includes('meeting') || lowerName.includes('sala')) {
      IconComponent = Users;
    } else if (lowerName.includes('cafe') || lowerName.includes('coffee') || lowerName.includes('cocina') || lowerName.includes('snack') || lowerName.includes('comedor')) {
      IconComponent = Coffee;
    } else if (lowerName.includes('servidor') || lowerName.includes('server') || lowerName.includes('rack')) {
      IconComponent = Server;
    } else if (lowerName.includes('planta') || lowerName.includes('plant') || lowerName.includes('jardin') || lowerName.includes('vegetacion')) {
      IconComponent = Sprout;
    } else if (lowerName.includes('bano') || lowerName.includes('aseo') || lowerName.includes('toilet') || lowerName.includes('wc') || lowerName.includes('ducha')) {
      IconComponent = Bath;
    } else if (lowerName.includes('impresora') || lowerName.includes('print')) {
      IconComponent = Printer;
    } else if (lowerName.includes('sms') || lowerName.includes('chat') || lowerName.includes('mensaje')) {
      IconComponent = MessageSquare;
    } else if (lowerName.includes('mail') || lowerName.includes('correo') || lowerName.includes('email')) {
      IconComponent = Mail;
    } else if (lowerName.includes('whatsapp') || lowerName.includes('phone') || lowerName.includes('telefono') || lowerName.includes('movil')) {
      IconComponent = Smartphone;
    } else if (lowerName.includes('pedido') || lowerName.includes('orden') || lowerName.includes('tienda') || lowerName.includes('order')) {
      IconComponent = ShoppingCart;
    } else if (lowerName.includes('conta') || lowerName.includes('factura') || lowerName.includes('finanza') || lowerName.includes('balance')) {
      IconComponent = BarChart2;
    } else if (lowerName.includes('madera') || lowerName.includes('wood') || lowerName.includes('suelo') || lowerName.includes('piso') || lowerName.includes('parquet')) {
      IconComponent = Layers;
    } else if (lowerName.includes('seguridad') || lowerName.includes('guard')) {
      IconComponent = Shield;
    } else {
      IconComponent = Box;
    }
  }

  return (
    <IconComponent
      className={className}
      size={size}
      style={color ? { color } : undefined}
    />
  );
};

export default AppIcon;
